import { MessageStore } from './message-store';

export class Subscription extends MessageStore {
}
